const currencyLocales = {
  usd: 'en-US',
  aud: 'en-AU',
  cad: 'en-CA',
  eur: 'de-DE',
  gbp: 'en-GB',
}

/**
 * Moves the Euro sign from the end to the beginning of the amount
 */
const moveEuroSign = (amount) => `€${amount.replace(/\u00A0€/, '')}`
/**
 * Formats a price amount with the appropriate currency symbol
 */
export const formatAmount = (amount, currency = 'USD') => {
  const locale = currencyLocales[currency.toLowerCase()] || 'en-US'
  // Use Intl.NumberFormat for proper currency formatting
  const formattedAmount = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)

  return locale === 'de-DE' ? moveEuroSign(formattedAmount) : formattedAmount
}

const formatCurrency = (amount, currency = 'USD') => {
  if (amount <= 0) {
    return ''
  }

  return formatAmount(amount, currency)
}

/**
 * Formats a price amount in cents with the appropriate currency symbol
 */
export function formatCurrencyFromCents(
  amountCents,
  currency = 'USD'
) {
  if (amountCents <= 0) {
    return ''
  }
  return formatCurrency(amountCents / 100, currency)
}
